// extracted by mini-css-extract-plugin
export default {"addToCartControl":"q2-z","giftCard":"r2-z","btnContainer":"s2-z","cartButton":"t2-z","disabled":"u2-z"};